import React from 'react';
import loadable from '@loadable/component';
import Loading from './Loading.js';

const StaticNonStaticMapBase = loadable(() => import(
												'./StaticNonStaticMapBase.js'),
												{
													ssr: false,
													fallback: <center>
																<Loading style={{maxHeight: "100%", maxWidth: "100%"}}/>
															  </center>
												});

const StaticNonStaticMapBaseLoadable = function(props) {

	return <div style={props.style}>
			<StaticNonStaticMapBase {...props} />
	</div>;
};

export default StaticNonStaticMapBaseLoadable;